import React from "react";
import {
  Button, DialogActions, DialogContent, Grid
} from '@mui/material';
import TextInput from "@/common/components/text-input/text-input";
import Dropdown from "@/common/components/dropdown/dropdown";
import SwitchInput from "@/common/components/switch-input/switch-input";
import AnimateButton from "@/from-theme/components/@extended/AnimateButton";
import { FormattedMessage } from 'react-intl';
import useCreateEditGradeListMaster from "./hooks/useCreateEditGradeListMaster";
import PropTypes from "prop-types";
import { apiStatuses } from "@/store/api/constants";
import Spinner from "@/common/components/spinner/spinner";
import ErrorInPage from "@/common/components/error-in-page/error-in-page";
import useGetGradeData from "@/common/hooks/useGetGradeMaster";

function CreateEditGradeListMaster({
  closeModal, activeEditId
}) {
  const { getGradeOptions, getGradeLoading } = useGetGradeData();
  const {
    values, formik, getEditGradeListStatus,
    getEditGradeListErrMsg, saveGradeListStatus, updateGradeListStatus,
  } = useCreateEditGradeListMaster(activeEditId);
  const isPending = [saveGradeListStatus, updateGradeListStatus].includes(apiStatuses.pending);
  const {
    gradeId, gradeListName, activeStatus
  } = values;

  return (
    <>
      {getEditGradeListStatus === apiStatuses.pending && activeEditId
        && <Spinner />}
      {getEditGradeListStatus === apiStatuses.rejected && activeEditId && (
        <ErrorInPage message={getEditGradeListErrMsg} />
      )}
      {(getEditGradeListStatus === apiStatuses.succeeded || !activeEditId) &&
        <form onSubmit={formik.handleSubmit}>
          <DialogContent dividers>
            <Grid container spacing={1.25} style={{paddingBottom:'240px'}}>
            <Grid item xs={12} sm={12} md={4} lg={6}>
                <Dropdown
                  options={getGradeOptions}
                  loading={getGradeLoading}
                  placeholder="grade-name"
                  inputLabel="grade-name"
                  value={gradeId}
                  formik={formik}
                  name="gradeId"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="grade-list-name" size="small" fullWidth
                  value={gradeListName}
                  inputLabel="grade-list-name"
                  formik={formik}
                  name="gradeListName"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={6}>
                <SwitchInput
                  inputLabel="activeStatus"
                  leftLabel="inactive"
                  rightLabel="active"
                  value={activeStatus}
                  formik={formik}
                  name="activeStatus"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="error" onClick={closeModal} variant="outlined" disabled={isPending}
             sx={{ mr: 1 }}>
              <FormattedMessage id={"cancel"} />
            </Button>
            <AnimateButton>
              <Button type="submit" variant="contained" disabled={isPending} sx={{ mr: 1 }}>
                <FormattedMessage id={"save"} />
              </Button>
            </AnimateButton>
          </DialogActions>
        </form>
      }
    </>
  )
}

CreateEditGradeListMaster.propTypes = {
  closeModal: PropTypes.func.isRequired,
  activeEditId: PropTypes.bool,
};

CreateEditGradeListMaster.defaultProps = {
  activeEditId: 0,
};

export default CreateEditGradeListMaster;